import { InputLabel } from '@mui/material';
import MUIRadio, { RadioProps } from '@mui/material/Radio';
import React from 'react';

interface Props extends RadioProps {
  checked: boolean;
  label: string;
  labelClassName?: string;
  value: string;
}

const RadioButton = ({ value, label, labelClassName, ...props }: Props) => {
  return (
    <React.Fragment>
      <MUIRadio id={value} value={value} size="small" {...props} />
      <InputLabel htmlFor={value} className={labelClassName}>
        {label}
      </InputLabel>
    </React.Fragment>
  );
};

export default RadioButton;
